export enum CapitalistAnim {
  IDLE = "02_cap_idle",
  CLIMB = "04_cap_climb",
  FALL = "05_cap_fall",
}
export enum CharacterAnim {
  IDLE = "02_idle",
  CLIMB = "04_climb",
  FALL = "05_fall",
}
